// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__QaZA7","navbar__links":"Navbar_navbar__links__7UJNu","navbar__link":"Navbar_navbar__link__ceyDF"};